import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretRightDouble16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCaretRightDouble16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.854 2.147a.5.5 0 1 0-.708.708L7.293 8l-5.147 5.147a.5.5 0 1 0 .708.707l5.5-5.5L8.707 8l-.353-.353zm5.5 0a.5.5 0 1 0-.708.708L12.793 8l-5.147 5.147a.5.5 0 1 0 .708.707l5.5-5.5.353-.354-.354-.353z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretRightDouble16);
